//#region IMPORT
import React, { useRef } from 'react';
/** Components Import */
import {
  Unstable_Grid2 as Grid,
  Box,
  Typography,
  Paper,
  styled,
  Chip,
  Divider,
  Alert,
  Slide,
} from '@mui/material';

import { AuthButton, Dialog } from '../../../../Components/MUIs';
import {
  AttachFile as AttachFileIcon,
  Download as DownloadIcon,
} from '@mui/icons-material';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import Global from '../../../../Services/Common/Global';
//#endregion

const FileChip = styled(Chip)(({ theme }) => ({
  margin: theme.spacing(0.5),
  padding: theme.spacing(1),
  height: 'auto',
  borderRadius: '12px',
  '& .MuiChip-label': {
    padding: theme.spacing(1, 1.5),
    fontSize: '14px',
    fontWeight: 500,
  },
  transition: 'all 0.25s ease',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    backgroundColor: '#F3F4FF',
  },
}));
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
function NOT_BASIC_01_01(props) {
  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="Notice1"
          searchBox="N"
          addYn="N"
          saveYn="N"
          searchYn="N"
          printYn="N"
          deleteYn="N"
          buttonsSx={{
            backgroundColor: 'transparent',
          }}
          grids={
            <Box
              sx={{
                p: { xs: 2, md: 4 },
                overflowY: 'auto',
                background: '#ffffffff',
                borderRadius: '16px',
                boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
              }}
            >
              <Box sx={{ mb: 3 }}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    color: '#4e4caf',
                    fontWeight: 700,
                    mb: 0.5,
                  }}
                >
                  {props.inputs?.gubunNm || ''}
                </Typography>
                <Typography
                  fontSize={26}
                  fontWeight={800}
                  sx={{
                    mb: 1,
                    color: '#222',
                    lineHeight: 1.3,
                  }}
                >
                  {props.inputs?.title || ''}
                </Typography>
                <Typography fontSize={14} sx={{ color: '#888' }}>
                  {props.inputs?.name || ''}
                  {` ${props.inputs?.createDate?.substring(0, 10) ?? ''}`}
                </Typography>
              </Box>

              <Divider sx={{ mb: 3 }} />

              <Paper
                elevation={0}
                sx={{
                  background: '#fff',
                  borderRadius: '12px',
                  minHeight: '40vh',
                  padding: 3,
                  border: '1px solid #eee',
                }}
              >
                <Box
                  sx={{
                    fontSize: '17px',
                    color: '#333',
                    lineHeight: 1.8,
                    textAlign: 'left',
                    display: 'block',
                    // 모든 블록 요소가 세로로 쌓이도록 강제
                    '& > *': {
                      display: 'block',
                      width: '100%',
                    },
                    // p 태그 스타일 (블록 요소로 강제)
                    '& p': {
                      display: 'block !important',
                      marginBottom: '12px',
                      marginTop: 0,
                      padding: 0,
                      textAlign: 'left',
                      width: '100%',
                    },
                    // div 태그 스타일 (SunEditor가 div로 줄바꿈 처리)
                    '& div': {
                      display: 'block !important',
                      marginBottom: '8px',
                      padding: 0,
                      width: '100%',
                    },
                    // 리스트는 자체적으로 블록이므로 유지
                    '& ol, & ul': {
                      display: 'block !important',
                      margin: '16px 0',
                      paddingLeft: '32px',
                      width: '100%',
                    },
                    // 순서 있는 리스트 (ol) 스타일
                    '& ol': {
                      listStyleType: 'decimal',
                      listStylePosition: 'outside',
                      textAlign: 'left',
                      direction: 'ltr',
                    },
                    // 순서 없는 리스트 (ul) 스타일
                    '& ul': {
                      listStyleType: 'disc',
                      listStylePosition: 'outside',
                      textAlign: 'left',
                      direction: 'ltr',
                    },
                    // 리스트 아이템 스타일
                    '& li': {
                      display: 'list-item !important',
                      marginBottom: '8px',
                      paddingLeft: '8px',
                      lineHeight: 1.8,
                      textAlign: 'left',
                    },
                    // 리스트 아이템 안의 div, p 태그 스타일 (인라인 유지)
                    '& li div, & li p': {
                      display: 'inline !important',
                      marginBottom: '0px',
                      marginTop: '0px',
                      padding: 0,
                      textAlign: 'left',
                    },
                    // br 태그 스타일
                    '& br': {
                      display: 'block',
                      content: '""',
                      marginBottom: '0.5em',
                    },
                    // 중첩 리스트 스타일
                    '& ul ul': {
                      listStyleType: 'circle',
                      marginTop: '8px',
                      marginBottom: '8px',
                    },
                    '& ol ol': {
                      listStyleType: 'lower-alpha',
                      marginTop: '8px',
                      marginBottom: '8px',
                    },
                    '& ul ol, & ol ul': {
                      listStyleType: 'decimal',
                      marginTop: '8px',
                      marginBottom: '8px',
                    },
                    // strong, b 태그 스타일
                    '& strong, & b': {
                      fontWeight: 700,
                    },
                    // 빈 태그 처리
                    '& div:empty, & p:empty': {
                      margin: 0,
                      padding: 0,
                      height: '1em',
                      display: 'block',
                    },
                  }}
                  dangerouslySetInnerHTML={{
                    __html: props.inputs?.comment || '',
                  }}
                />
              </Paper>

              {/*  첨부 파일 섹션 */}
              {props.uploadedFiles?.length > 0 && (
                <Box sx={{ mt: 4 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: 700,
                      color: '#333',
                      mb: 2,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                    }}
                  >
                    <AttachFileIcon sx={{ fontSize: 20, color: '#4e4caf' }} />
                    첨부 파일 ({props.uploadedFiles.length}개)
                  </Typography>

                  {/* 이미지 파일 섹션 */}
                  {props.uploadedFiles.some((f) =>
                    /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(f.fileName)
                  ) && (
                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1.5,
                        mb: 3,
                      }}
                    >
                      {props.uploadedFiles
                        .filter((f) =>
                          /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(f.fileName)
                        )
                        .map((item, idx) => (
                          <Box
                            key={idx}
                            sx={{
                              position: 'relative',
                              width: 110,
                              height: 110,
                              border: '1px solid #ddd',
                              borderRadius: '12px',
                              overflow: 'hidden',
                              backgroundColor: '#fefefe',
                              boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                              transition: 'all 0.2s ease',
                              '&:hover': {
                                transform: 'scale(1.03)',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                              },
                            }}
                          >
                            <img
                              src={`${Global.file.useUrl}files/${item.filePath}`}
                              alt={item.fileName}
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                              }}
                            />
                            <button
                              style={{
                                position: 'absolute',
                                top: 4,
                                right: 4,
                                border: 'none',
                                backgroundColor: 'rgba(255,255,255,0.7)',
                                borderRadius: '50%',
                                cursor: 'pointer',
                                padding: '4px',
                              }}
                              onClick={() => props.DownloadLogic1(item)}
                            >
                              <DownloadIcon width={18} height={18} />
                            </button>
                          </Box>
                        ))}
                    </Box>
                  )}

                  {/* ✅ 일반 파일 섹션 */}
                  {props.uploadedFiles.some(
                    (f) => !/\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(f.fileName)
                  ) && (
                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1,
                        mt: 1,
                      }}
                    >
                      {props.uploadedFiles
                        .filter(
                          (f) =>
                            !/\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(f.fileName)
                        )
                        .map((item, idx) => (
                          <FileChip
                            key={idx}
                            icon={<AttachFileIcon />}
                            label={item.fileName}
                            onClick={() => props.DownloadLogic1(item)}
                            color="primary"
                            variant="outlined"
                          />
                        ))}
                    </Box>
                  )}
                </Box>
              )}
            </Box>
          }
          conditions={[
            {
              type: 'button',
              name: '새 글 쓰기',
              onClick: () => {
                props.navigate('/Notice2', {
                  state: { coCd: props.state?.coCd ?? '' },
                });
              },
            },
            {
              type: 'button',
              name:
                props.lanInfo.length === 0
                  ? ''
                  : props.lanInfo.find(
                      (f) => f.lanType === 'CALL' && f.lanId === 'List'
                    ).lanNm,
              onClick: () => {
                props.navigate('/NoticeBoard', {
                  state: { coCd: props.state?.coCd ?? '' },
                });
              },
            },
            {
              type: 'button',
              name: '수정',
              onClick: () => {
                props.navigate('/Notice2', {
                  state: {
                    data: props.inputs,
                    coCd: props.state?.coCd ?? '',
                  },
                });
              },
            },
            {
              type: 'button',
              name: '삭제',
              onClick: () => {
                props.setDialogToggle1({
                  ...props.dialogToggle1,
                  open: true,
                  title: '삭제',
                  content: [
                    <Box sx={{ width: '400px', p: 2 }}>
                      <Typography variant="h6" sx={{ mb: 2 }}>
                        선택한 항목을 삭제하시겠습니까?
                      </Typography>
                      <Alert severity="warning">
                        삭제된 데이터는 복구할 수 없습니다.
                      </Alert>
                    </Box>,
                  ],
                });
              },
            },
          ]}
        />
      </Grid>
      <Dialog
        sx={{ height: '100%' }}
        open={props.dialogToggle1.open}
        onClose={() => props.setDialogToggle1(false)}
        TransitionComponent={Transition}
        title={props.dialogToggle1.title}
        content={props.dialogToggle1.content}
        contentText={props.dialogToggle1.contentText}
        actions={props.dialogToggle1.actions}
        useSaveButton={true}
        useCloseButton={true}
        saveButtonName={'삭제'}
        closeButtonName={'닫기'}
        onSave={() => props.Save1()}
      />
    </Grid>
  );
}

export default NOT_BASIC_01_01;
